























import { computed, ref, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "PrivateInvitationConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    value: { type: Boolean, required: true },
    price: { type: Number, default: 0 },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const buttonText = computed(() =>
      props.price > 0 ? $t("Request for {0}/min", [formatMoneyString(props.price)]) : $t("Request")
    );

    const onSendInvitation = () => {
      loading.value = true;
      emit("createInvitation", () => {
        loading.value = false;
      });
    };

    return { loading, buttonText, onSendInvitation };
  },
});
